import { render, staticRenderFns } from "./Summary.vue?vue&type=template&id=1edb40cf&scoped=true&"
import script from "./Summary.ts?vue&type=script&lang=ts&"
export * from "./Summary.ts?vue&type=script&lang=ts&"
import style0 from "./summary.scss?vue&type=style&index=0&id=1edb40cf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edb40cf",
  null
  
)

export default component.exports